export default __webpack_public_path__ + "static/media/cinema-banner.3ce07207.png";